import { renderValueSafeInline } from  "./valueFormat"

// Battery compact
export const renderBatteryCompact = (batt) => {
  if (!batt) return "-";
  const arr = Array.isArray(batt)
    ? batt
    : typeof batt === "object"
    ? [batt]
    : [batt];
  if (arr.length === 0) return "-";
  return (
    <div style={{ fontSize: 12 }}>
      {arr.map((entry, idx) => {
        if (entry === null || entry === undefined)
          return <div key={idx}>-</div>;
        if (typeof entry === "object" && !Array.isArray(entry)) {
          const V = entry.V ?? entry.v ?? entry.Voltage ?? "-";
          // gjør A mutable fordi vi kan endre den i validering
          let A = entry.A ?? entry.a ?? entry.Current ?? "-";
          // sørg for at A er et tall før vi sammenligner urealistiske verdier
          if (typeof A === "number") {
            if (A < -2000) {
              A = "-"; // urealistisk ladestrøm håndteres som "-"
            }
          } else if (typeof A === "string") {
            // forsøk parse hvis det er en string som ser ut som et tall
            const parsed = parseFloat(A.replace(",", "."));
            if (!isNaN(parsed)) {
              if (parsed < -2000) A = "-";
              else A = parsed;
            }
            // ellers behold original string (vises videre)
          }
          const SOC = entry.SOC ?? entry.soc ?? "-";
          return (
            <div key={idx}>
              {V !== "-" && A !== "-" && SOC !== "-" ? (
                <>
                  <strong>{idx + 1}.</strong> {V}V Ladestrøm: {A}A SOC: {SOC}%
                </>
              ) : (
                <>
                  <strong>{idx + 1}.</strong> Batterikommunikasjonsfeil...
                </>
              )}
            </div>
          );
        }
        return (
          <div key={idx}>
            <strong>{idx + 1}.</strong> {renderValueSafeInline(entry)}
          </div>
        );
      })}
    </div>
  );
};
